import { Component, ChangeDetectorRef, ChangeDetectionStrategy, ViewRef, Output, EventEmitter, HostListener } from '@angular/core';
import { ValueField } from '../../models/valuefield';
import { MathFunction } from '../../models/mathfunction';

@Component({
  selector: 'mdg-formulaselector',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div *ngIf="showFormula" class='mdg-filter-container'>
  <div class="mdg-filter-popup-container">
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <div class='row'>
          <div class="col-md-12 col-sm-12 col-xs-12">
            <h3>Field : {{value.column.displayName}}</h3>
          </div>
          <hr class="buffer-5-0">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <h3>Formula : {{value.mathFn.Name}}</h3>
          </div>
        </div>
        <hr class="buffer-5-0">
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 content">
        <div class='border-top-ddd border-left-ddd border-right-ddd'>
          <div class="padding-5 bg-f7f7f7">List of Formula(s)
          </div>
        </div>
        <div class="mdg-filter-stack-container overflow-y border-ddd">
          <div class="border-bottom-ddd padding-5 cursor-pointer" *ngFor="let col of value.mathFns" (click)='selectFormula(col)' title="{{col.Name}}">
            <i class='fa fa-reorder cursor-move font-10'></i> {{col.Name}}
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <hr class="buffer-5-0">
        <div class='row'>
          <div class="col-xs-12 text-lg-right text-md-right text-sm-right">
            <button class='btn btn-sm btn-primary right-buffer-10' (click)='applyFilter()'>Apply</button>
            <button class='btn btn-sm btn-default' (click)='CancelFormula()'>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
})
export class MDGFormulaSelectorComponent {
  value: ValueField = new ValueField();
  formula: any[] = [];
  @Output() updateFormula: EventEmitter<MathFunction> = new EventEmitter<MathFunction>();
  showFormula: boolean = false;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.showFormula) {
      this.showFormula = false;
    }
  }

  constructor(private cdRef: ChangeDetectorRef) { }

  ShowFormula(val: ValueField) {
    this.value = Object.create(val);
    this.showFormula = true;
    this.detectChanges();
  }

  selectFormula(forml: MathFunction) {
    this.value.mathFn = forml;
  }

  applyFilter() {
    setTimeout(() => {
      this.updateFormula.emit(this.value.mathFn);
    }, 10);
    this.showFormula = false;
  }

  CancelFormula() {
    this.showFormula = false;
  }

  detectChanges() {
    setTimeout(() => {
      if (
        this.cdRef !== null &&
        this.cdRef !== undefined &&
        !(this.cdRef as ViewRef).destroyed
      ) {
        this.cdRef.detectChanges();
      }
    }, 250);
  }
}
